module.exports = __webpack_public_path__ + "img/line-break.8dc3396d.svg";